import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { Ripple } from 'vuetify/lib/directives'
import { colors } from 'vuetify/lib';
import VueTextAreaOversize from 'vue-textarea-autosize'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
Vue.use(VueTextAreaOversize)
Vue.use(Vuetify, {
  directives: {
    Ripple
  }
});

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: '#4232a8',
            secondary: colors.orange.darken3,
            background: "#F9F9F9", 
            backgroundAddSpot: "#d9d7d7",
          },
        },
      },
});
